import { render, staticRenderFns } from "./CreateKokuban.vue?vue&type=template&id=1b848060&scoped=true&"
import script from "./CreateKokuban.vue?vue&type=script&lang=js&"
export * from "./CreateKokuban.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b848060",
  null
  
)

export default component.exports